import { BusinessPlanOptions, FamilyPlanOptions, Plan } from "@ecologi/shared";
import { toast } from "react-toastify";
import { CheckoutFormFields } from "../CheckoutForm";

export type OnSubmitCheckoutFormProps = {
  elements: any;
  formValues: CheckoutFormFields;
  isBusinessPlan: boolean;
  isCardCVCValid: boolean;
  isCardExpiryValid: boolean;
  isCardNumberValid: boolean;
  isFamilyPlan: boolean;
  numLocalTrees: number;
  selectedPlan:
    | Plan
    | {
        price: number;
        title: string;
      };
  selectedPlanAddons: FamilyPlanOptions | BusinessPlanOptions | undefined;
  selectedPlanId: string;
  subscribeUser: any;
  captchaToken: string;
};

export const onSubmitCheckoutForm = async ({
  elements,
  formValues,
  isBusinessPlan,
  isCardCVCValid,
  isCardExpiryValid,
  isCardNumberValid,
  isFamilyPlan,
  numLocalTrees,
  selectedPlan,
  selectedPlanAddons,
  selectedPlanId,
  subscribeUser,
  captchaToken,
}: OnSubmitCheckoutFormProps) => {
  if (selectedPlan.price <= 0) {
    const errorMessage = isBusinessPlan
      ? "Please add some employees to your plan"
      : isFamilyPlan
      ? "Please add your family members to the plan"
      : "Please select a plan";
    toast.warn(errorMessage);
    return;
  }

  // It automatically pulls the other elements from the same form
  const cardElement = elements ? elements.getElement("cardNumber") : null;
  if (!cardElement) {
    toast.error(
      "An error has occurred with our payment provider. Please refresh and try again."
    );
    return;
  }

  // Assert card fields are filled out
  if (
    [isCardNumberValid, isCardCVCValid, isCardExpiryValid].some(
      (v) => v == false
    )
  ) {
    toast.error(
      "The entered card details are invalid. Please re-check them & try again."
    );
    return;
  }

  const {
    groupName,
    isTermsAndConditionsAccepted,
    isMarketingAccepted,
    ...restFormValues
  } = formValues;

  await subscribeUser({
    cardElement,
    captchaToken,
    formValues: {
      groupName: groupName ? groupName : "",
      ...restFormValues,
    },
    selectedPlanAddons,
    selectedPlanId,
    numLocalTrees,
  });
};
